<div class="modal-header" style="padding: 0.5rem;">
    <div class="row" style="width: 100%;">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
        </div>
    </div>
</div>
<div class="modal-body">
    <div class="row" style="justify-content: center;">
        <div class="col-md-6" *ngIf="Datas.ProfileImage != null && Datas.ProfileImage != ''">
            <div class="row" style="line-height: 12px;">
                <div class="col-12">
                    <label class="text-label">Profile Image</label>
                </div>
                <div class="col-12">
                    <img *ngIf="isShow(Datas.ProfileImage)" mat-card-image style="max-height: 20rem;width: inherit;"
                        [src]="Datas.ProfileImage" />
                    <div *ngIf="!isShow(Datas.ProfileImage)" class="initial-image-big">
                        <div class="image">
                            {{common.getInitial(Datas.Name)}}
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <label name="Name" class="text-label-dark">{{Datas.Name}}</label>
                </div>
                <div class="col-12">
                    <label name="Name" class="text-label-dark2" *ngIf="Datas.Code != '' && Datas.Code != null">#{{Datas.Code}}</label>
                </div>
                <div class="col-12">
                    <label name="Name" class="text-label-dark2">{{Datas.Designation}}</label>
                </div>
                <div class="col-12">
                    <label name="Name" class="text-label-dark2" *ngIf="Datas.ContactNo != '' && Datas.ContactNo != null">Contact No : {{Datas.ContactNo}}</label>
                </div>
            </div>
        </div>
        <div class="col-md-6" *ngIf="Datas.ImgPath != null && Datas.ImgPath != ''">
            <div class="row" style="line-height: 12px;">
                <div class="col-12">
                    <label class="text-label">Attendance Image</label>
                </div>
                <div class="col-12">
                    <img *ngIf="isShow(Datas.ImgPath)" mat-card-image style="max-height: 20rem;width: inherit;"
                        [src]="Datas.ImgPath" />
                    <div *ngIf="!isShow(Datas.ImgPath)" class="initial-image-big">
                        <div class="image">
                            {{common.getInitial(Datas.Name)}}
                        </div>
                    </div>
                </div>
                <div class="col-12 my-1" *ngIf="Datas.MTitle1 != null && Datas.MTitle1 != ''">
                    <label name="Name" class="text-label-dark">{{Datas.MTitle1}} : {{Datas.MData1 | date: 'dd MMM,
                        yyyy'}}</label>
                </div>
                <div class="col-12" *ngIf="Datas.MTitle2 != null && Datas.MTitle2 != ''">
                    <label name="Name" class="text-label-dark">{{Datas.MTitle2}} : {{Datas.MData2 | date :
                        'H:mm:ss'}}</label>
                </div>
                <div style="background-color: #EBF3FE" class="mt-2"
                    *ngIf="(Datas.Address != null && Datas.Address != '') || (Datas.Latitude != null && Datas.Latitude != '' && Datas.Longitude != null && Datas.Longitude != '') || (Datas.IsAttendanceMatch != null)">
                    <div class="col-12 my-1">
                        <div class="col-auto" *ngIf="Datas.Address != null && Datas.Address != '' && this.common.CompanyParameterValue.IsESSAddressAttendanceEnabled">
                            <span class="text-label-dark">Address : {{Datas.Address}}</span>
                        </div>
                        <div class="col-auto"
                            *ngIf="Datas.Latitude != null && Datas.Latitude != '' && Datas.Longitude != null && Datas.Longitude != ''">
                            <a class="text-label-dark" target="_blank"
                                [href]="'https://www.google.com/maps?q=' + Datas.Latitude + ',' + Datas.Longitude + '&z=11'">
                                Open in Map <i class="bi bi-map"></i></a>
                        </div>
                    </div>
                    <div class="col-12 my-1" *ngIf="Datas.IsAttendanceMatch != '' && Datas.IsAttendanceMatch != null && this.common.CompanyParameterValue.IsFaceCompare">
                        <span class="badge"
                            [ngClass]="{'success':Datas.IsAttendanceMatch, 'warning':!Datas.IsAttendanceMatch}">
                            {{Datas.IsAttendanceMatch?"Face Match : ":"Face not match : "}}
                            {{((Datas.AttendanceMatchPercentage??0) * 100)| number:'1.2-2'}}%</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>